import { render } from "./agreement.vue?vue&type=template&id=975ef288&scoped=true&ts=true"
import script from "./agreement.vue?vue&type=script&lang=ts"
export * from "./agreement.vue?vue&type=script&lang=ts"

import "./agreement.vue?vue&type=style&index=0&id=975ef288&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975ef288"]])

export default __exports__